<script>
  import Footer from "./components/Footer.svelte";
  import { Router } from "svelte-router-spa";
  import { routes } from "./routes";
  export let name;
</script>

<main class="bg-gray-900">
  <Router {routes} />
</main>

<style global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
  main {
    width: 100vw;
    height: calc(100vh);
    display: grid;
    place-content: center;
  }
  .color-picker-handle,
  .color-picker-controls,
  canvas {
    border-radius: 0px !important;
    color: rgb(17, 24, 39);
  }
</style>
